module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAABZklEQVRIS+2Xz0rDQBDGv4FApILWnLzqWYUcYqbHPoAPoEI8CPpOiqCI4l3oK2STVArqVfDoSVSQGAiMrBip7UrT+gcPO5BLMpPfMpnJzEcwWK/XaxZFsQdgDcCUyafGvRcA567r7vi+/zDoT6YXxHF8SERbAO4BVEEegOYIoPbVMdrm3q8zZl6vBVZKPQN4yvN8od1u65MjSZJIRI5GgCNmPtY+3W63UZblDYAZZp6uCxYAV8y8UgWICKVpuisi/hfwizAM94lIx76ZUuoSwDIzD2XWmGql1BC4xjcdcrHg/pTYVFfVaItrkm6yffwpa7adbDt9jMVJ+slOJzudTCvL/5pOSZJsi8iqqcKJKA3D8KD/2Y9VdRzHJ0S0YQKLyGmr1dr8FXCWZUtlWc6bwI7j3AVBcP1dsF7oH/M8X6wW+nF/IJ1Ox/U87xbALDM36i70WjFEAxJmXLaWO1r21JcwfyHaXgHJlEUuAdUs9gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/phone.png
// module id = Lfqn
// module chunks = 1